//todo 함수명 naming 변경

// 원리금균등 상환방식
export const calculateConstantAmortization = (
  loanAmount: number,
  loanTerm: number,
  interestRate: number,
) => {
  const calculatedPaymentData: any[] = [];
  const loanAmountByTenThousand = loanAmount * 10000;
  let loanBalance = loanAmountByTenThousand; //남은 대출 원금
  let interestTotal = 0; //총 이자 합계
  const yearInterestRate = interestRate / 12 / 100; //대출 이자율
  const denominator = Math.pow(yearInterestRate + 1, loanTerm) - 1;
  const numerator =
    loanAmountByTenThousand *
    yearInterestRate *
    Math.pow(yearInterestRate + 1, loanTerm);
  let monthlyPaymentTotal = Math.round(numerator / denominator); //월 상환금

  for (let i = 1; i <= loanTerm; i++) {
    let monthlyInterest = Math.round(loanBalance * yearInterestRate); //월 납부 이자
    interestTotal += monthlyInterest; //이자 합계 추가

    let monthlyPayment = monthlyPaymentTotal - monthlyInterest; //월 상환 원금
    loanBalance = i === loanTerm ? 0 : loanBalance - monthlyPayment; //남은 대출 원금

    calculatedPaymentData.push({
      count: i,
      monthlyPayment: monthlyPaymentTotal,
      monthlyInterest,
      loanBalance,
    });
  }

  return {
    calculatedPaymentData,
    interestTotal,
    totalPaymentAmount: interestTotal + loanAmountByTenThousand,
  };
};

//원금균등 상환방식
export const calculateConstant = (
  loanAmount: number,
  loanTerm: number,
  interestRate: number,
) => {
  const calculatedPaymentData: any[] = [];
  const loanAmountByTenThousand = loanAmount * 10000;
  let loanBalance = loanAmountByTenThousand; //남은 대출 원금
  let interestTotal = 0; //총 이자 합계
  let monthlyPayment = loanAmountByTenThousand / loanTerm; //월 상환 원금
  const yearInterestRate = interestRate / 12 / 100; //대출 이자율

  for (let i = 1; i <= loanTerm; i++) {
    let monthlyInterest = Math.round(loanBalance * yearInterestRate * 10) / 10;
    interestTotal += monthlyInterest;
    let monthlyPaymentTotal = monthlyPayment + monthlyInterest;
    loanBalance = i === loanTerm ? 0 : loanBalance - monthlyPayment;

    calculatedPaymentData.push({
      count: i,
      monthlyPayment: monthlyPaymentTotal,
      monthlyInterest,
      loanBalance,
    });
  }

  return {
    calculatedPaymentData,
    interestTotal,
    totalPaymentAmount: interestTotal + loanAmountByTenThousand,
  };
};

//만기일시 상환방식
export const calculateBulletRepayment = (
  loanAmount: number,
  loanTerm: number,
  interestRate: number,
) => {
  const calculatedPaymentData: any[] = [];
  const loanAmountByTenThousand = loanAmount * 10000;
  let loanBalance = loanAmountByTenThousand;

  let interestTotal = 0;

  const yearInterestRate = interestRate / 12 / 100;

  for (let i = 1; i <= loanTerm; i++) {
    if (i < loanTerm) {
      let monthlyInterest = Math.round(loanBalance * yearInterestRate);
      interestTotal += monthlyInterest;

      calculatedPaymentData.push({
        count: i,
        monthlyPayment: monthlyInterest,
        monthlyInterest,
        loanBalance,
      });
    } else {
      let monthlyInterest = Math.round(loanBalance * yearInterestRate);
      interestTotal += monthlyInterest;

      calculatedPaymentData.push({
        count: i,
        monthlyPayment: monthlyInterest + loanBalance,
        monthlyInterest,
        loanBalance,
      });
    }
  }

  return {
    calculatedPaymentData,
    interestTotal,
    totalPaymentAmount: interestTotal + loanAmountByTenThousand,
  };
};
